// extracted by mini-css-extract-plugin
module.exports = {"conditionalLink":"IndustryComparisonConditionalLink_conditionalLink__N_h0m","active":"IndustryComparisonConditionalLink_active__AUMEy"};